import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { Target } from "lucide-react";
import { Progress } from "antd";


const ActiveGoalsSummary = ( props ) => {
  const { percent} = props;

const activeGoalsLists = [
  {
    id: 1,
    title: "Complete Q4 Project Milestones",
    progress: 75,
    dueDate: "Dec 31, 2025",
  },
  {
    id: 1,
    title: "Mentor 2 Junior Developers",
    progress: 50,
    dueDate: "Dec 31, 2025",
  },
  {
    id: 1,
    title: "Submit 3 Technical Blogs",
    progress: 33,
    dueDate: "Dec 31, 2025",
  }
];
  	return (
        <HeaderComponent
          title="Active Goals"
          labelIcon={<Target size={20}/>}
          description="Track your Q4 2025 objectives"
        >
          {activeGoalsLists.map((item) => (
            <div className="border p-4 rounded-xl mt-3">
              <div className="flex items-center justify-between">
                <p className="font-medium text-sm">{item.title}</p>
                <p className="text-sm font-semibold text-emerald-600">{item.progress}%</p>
              </div>
              <Progress
                percent={item.progress}
                showInfo={false} 
                strokeColor="#22c55e"
                trailColor="rgba(34, 197, 94, 0.2)"
                strokeWidth={8} 
                strokeLinecap="round"
              />
              <p className="text-xs">Due: {item.dueDate}</p>
            </div>
          ))}
            

        </HeaderComponent>
);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ActiveGoalsSummary);
